import { createFileRoute } from '@tanstack/react-router'
import { PaymentLinksPage } from '~/components/routes/customers/payment-links/payment-links-page'
import { paymentLinksSearchSchema } from '~/components/routes/customers/payment-links/payment-links-search'
import { USERS_SCREEN_PERMISSIONS } from '~/components/routes/users/screens'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * Écran « Liens de paiement » (kanban #870, lot 7) : tous les liens, avec ou sans compte, même
 * garde que `GET /payment-links` (`read users.payment-links.link`).
 */
export const Route = createFileRoute('/_authenticated/users/payment-links')({
  staticData: {
    permission: USERS_SCREEN_PERMISSIONS['payment-links'],
  },
  validateSearch: paymentLinksSearchSchema,
  component: PaymentLinksPage,
})
withRoutePermissions(Route)
